import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import Product from '~/types/api/Product'
import ProductCard from '~/components/element/ProductCard'
import ProductCardCommercialElem from '~/components/element/ProductCardCommercialElem'
import s from '~/utils/s'
import AD_FOX_CONSTANTS from '~/types/enum/AdFoxEnum'
import checkIframes from '~/components/setStylesForAddBanners'

@Component
export default class ProductList extends Vue {
  @Prop({ required: true, type: Array })
  readonly products!: Product[]

  @Prop({ default: true, type: Boolean })
  readonly isCatalog!: boolean

  @Prop({ default: false, type: Boolean })
  readonly isUserList!: boolean

  @Prop({ default: 0, type: String })
  readonly count!: string

  @Prop({ default: false, type: Boolean })
  readonly isShowAds!: boolean

  isAdsVisible = true

  get isLoaded (): boolean {
    return s(this.$store).general.isLoaded
  }

  mounted () {
    this.$nextTick(() => {
      const banners = document.querySelectorAll('.banner')
      banners.forEach((banner) => {
        (banner as HTMLElement).style.border = '0'
      })
    })
  }

  @Watch('products', { deep: true })
  onProductsChanged () {
    if (this.isShowAds) {
      this.isAdsVisible = false
      this.$nextTick(() => {
        this.reloadAds()
      })
    }
  }

  reloadAds () {
    this.isAdsVisible = true
    this.$nextTick(() => {
      s(this.$store).advertising.addInfoInContainer(AD_FOX_CONSTANTS.inCatalog)
      checkIframes()
    })
  }

  isShowProductCardCommercialElems () {
    return s(this.$store).productCardsCommercial.productCardsCommercial.length > 0
  }

  render () {
    const link = s(this.$store).general.host + this.$route.fullPath
    return (
      <div class={{
        'catalog-product-list': true,
        'catalog-product-list--user-list': this.isUserList
      }} itemscope itemtype="https://schema.org/ItemList">
        <meta itemprop="url" content={link} />
        <meta itemprop="numberOfItems" content={this.count} />
        {this.products.length > 0 &&
        <div class="catalog-product-list__row">
          {this.products.map((e: Product, index: number) => {
            if ((index === 4 || (index === this.products.length - 1 && this.products.length - 1 < 4)) &&
              this.isShowProductCardCommercialElems()) {
              return [
                <div key={e.id} {...{
                  class: {
                    'catalog-product-list__col': true,
                    'catalog-product-list__col_adaptive': s(this.$store).categoryPage.category.isPreset
                  }
                }}>
                  <ProductCard {...{
                    props: {
                      product: e,
                      position: index,
                      isCatalog: this.isCatalog,
                      isUserList: this.isUserList
                    }
                  }} />
                </div>,
                <div {...{
                  class: {
                    'catalog-product-list__col': true,
                    'catalog-product-list__col_adaptive': s(this.$store).categoryPage.category.isPreset
                  }
                }}>
                  <ProductCardCommercialElem {...{
                    props: {
                      productCardCommercial: s(this.$store).productCardsCommercial.productCardsCommercial[0]
                    }
                  }}/>
                </div>
              ]
            }
            if ((index === 5 || (index === this.products.length - 1 && this.products.length - 1 < 5))) {
              return [this.isShowAds && this.isAdsVisible && s(this.$store).advertising.isActive && (
                <div
                  class={`catalog-product-list__col adfox ${s(this.$store).categoryPage.category.isPreset ? 'catalog-product-list__col_adaptive' : ''}`}
                  id={AD_FOX_CONSTANTS.inCatalog}>
                </div>),
              <div key={e.id} {...{
                class: {
                  'catalog-product-list__col': true,
                  'catalog-product-list__col_adaptive': s(this.$store).categoryPage.category.isPreset
                }
              }}>
                <ProductCard {...{
                  props: {
                    product: e,
                    position: index,
                    isCatalog: this.isCatalog,
                    isUserList: this.isUserList
                  }
                }} />
              </div>
              ]
            } else {
              return (
                <div key={e.id} {...{
                  class: {
                    'catalog-product-list__col': true,
                    'catalog-product-list__col_adaptive': s(this.$store).categoryPage.category.isPreset
                  }
                }}>
                  <ProductCard {...{
                    props: {
                      product: e,
                      position: index,
                      isCatalog: this.isCatalog,
                      isUserList: this.isUserList
                    }
                  }} />
                </div>
              )
            }
          })}
        </div>
        }
      {!this.isLoaded && this.products.length === 0 && (
        <div>
          <h2 class="product-list-empty-notification">
            Извините, в выбранном регионе нет товаров этой категории
          </h2>
        </div>
      )}
      </div>
    )
  }
}
